var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCity = function SvgCity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    role: "presentation",
    focusable: "false"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5.566V20h2v-4h4v4h2V5.566l-4-2.4-4 2.4ZM13 17v3h-2v-3h2Zm9 4V9l-5 1.667V5l-5-3-5 3v4H2v12h20Zm-5-9.28V20h4v-9.613l-4 1.334ZM7 10H3v10h4V10Zm7-2V7h-4v1h4Zm0 2v1h-4v-1h4Zm0 4v-1h-4v1h4ZM4 12h2v1H4v-1Zm16 3v-1h-2v1h2ZM4 15h2v1H4v-1Zm16 3v-1h-2v1h2Z",
    fill: "currentColor"
  })));
};
export default SvgCity;